import { FilterChangedEvent } from '@ag-grid-community/core/dist/esm/es6/events';
import { IFloatingFilter, IFloatingFilterParams } from '@ag-grid-community/core/dist/esm/es6/filter/floating/floatingFilter';
import { Component } from '@angular/core';
import { FormControl, UntypedFormGroup } from '@angular/forms';

export interface DropdownFilterValue {
    // TRANSLATION KEY!
    value: string | number | boolean;
    label?: string;
    // Commented since we can't display icons inside select option tags
    // displayLabel?: boolean;
    // icon?: string;
    // displayIcon?: boolean;
}

@Component({
    selector: 'app-radio-floating-filter',
    templateUrl: './dropdown-floating-filter.component.html',
    styleUrls: ['./dropdown-floating-filter.component.scss'],
    standalone: false,
})
export class DropdownFloatingFilterComponent implements IFloatingFilter {
    public params!: IFloatingFilterParams;
    public options!: DropdownFilterValue[];
    public parentFilter: any;

    public form = new UntypedFormGroup({ select: new FormControl<string>('') });

    agInit(params: IFloatingFilterParams): void {
        this.params = params;
        this.options = (params.filterParams as any).values;
    }

    onParentModelChanged(parentModel: any, filterChangedEvent?: FilterChangedEvent | null): void {
        this.form.get('select')?.setValue(parentModel?.filter ?? '');
        this.parentFilter = parentModel;
    }

    selectRadioOption(event: any) {
        const gridFilterModel = this.params.api.getFilterModel();
        gridFilterModel[this.params.column.getColId()] = {
            filterType: 'text',
            type: 'equals',
            filter: event.target.value,
        };

        this.params.api.setFilterModel(gridFilterModel);
    }
}
